<template>
	<el-input
		v-model="value"
		:placeholder="placeholder"
		class="input--lite"
		:class="showErr ? 'input--err' : ''"
		@keyup.enter="$emit('inputenter', value)"
		@change="$emit('inputchange', value)"
		clearable
		@clear="$emit('inputclear')"
		@blur="$emit('inputblur', value)"
	>
		<template #prefix>
			<slot />
		</template>
	</el-input>

	<el-alert :title="errMsg" type="error" v-if="showErr" class="input--lite__error" :closable="false" />
</template>

<script>
import { texts } from '../../utils/texts.ts';

export default {
	name: 'InputLite',
	data() {
		return {
			value: '',
		};
	},
	props: {
		inputValue: {
			type: String,
			default: '',
		},
		placeholder: {
			type: String,
			default: '',
		},
		showErr: {
			type: Boolean,
			default: false,
		},
		errMsg: {
			type: String,
			default: '',
		},
	},
	emits: ['inputenter', 'inputclear', 'inputblur', 'inputchange'],
	watch: {
		inputValue(newVal) {
			this.value = newVal;
		},
	},
	mounted() {
		this.value = this.inputValue;
	},
};
</script>

<style lang="scss"></style>
